import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://acmtksghukzdsxcglnne.supabase.co'
const supabaseAnonKey = 'sb_publishable_DFDYZhw31YGP1XnTFUcZjQ_zO4nxFbR'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
